import { createStructuredSelector } from 'reselect';
import { useLocation } from 'react-router';
import core, { App } from '@gin-betting/core';

import { useMemoSelector } from 'hooks';
import matchList from 'modules/match-list';

const {
    viewport: {
        selectors: { selectIsCompact },
    },
} = core;

const {
    selectors: { selectFetchStatus },
} = matchList;

interface Output {
    fetchStatus: App.FetchStatus;
    isCompact: boolean;
}

const selectProps = createStructuredSelector({
    fetchStatus: selectFetchStatus,
    isCompact: selectIsCompact,
});

const useOutrights = (): Output => {
    const location = useLocation();

    const { fetchStatus, isCompact } = useMemoSelector(selectProps, {
        location,
    });

    return {
        fetchStatus,
        isCompact,
    };
};

export default useOutrights;
